import { createApi } from '@reduxjs/toolkit/query/react'
import { Methods, NewResponse } from 'types/request.ts'
import { GetMonthlyProductsTargetsResponse, GetMonthlyProductsVolumesResponse, TagTypes } from 'store/queries/bolt-api/types.ts'
import { baseQueryWithReauth } from 'store/queries/bolt-api/utils.ts'
import { MonthlyProductTarget, MonthlyProductVolume, UpsertMonthlyProductTargetType } from 'types/product.ts'

export const boltApi = createApi({
  reducerPath: 'boltApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(TagTypes),
  endpoints: (builder) => ({
    // ============================
    // MUTATIONS
    // ============================

    // UPDATE MONTHLY PRODUCTS TARGETS
    updateMonthlyProductsTargets: builder.mutation<void, UpsertMonthlyProductTargetType[]>({
      query: (targets) => ({
        method: Methods.PATCH,
        url: '/products/monthly-targets',
        body: { targets }
      }),
      invalidatesTags: [TagTypes.MONTHLY_PRODUCTS_TARGETS]
    }),

    // ============================
    // QUERIES
    // ============================

    // GET MONTHLY PRODUCTS TARGETS
    getMonthlyProductsTargets: builder.query<MonthlyProductTarget[], void>({
      providesTags: [TagTypes.MONTHLY_PRODUCTS_TARGETS],
      query: () => ({
        method: Methods.GET,
        url: '/products/monthly-targets'
      }),
      transformResponse: ({ success, data }: NewResponse<GetMonthlyProductsTargetsResponse>) => {
        return success && data ? data.monthlyTargets : []
      }
    }),

    // GET MONTHLY PRODUCTS VOLUMES
    getMonthlyProductsVolumes: builder.query<MonthlyProductVolume[], void>({
      providesTags: [TagTypes.MONTHLY_PRODUCTS_VOLUMES],
      query: () => ({
        method: Methods.GET,
        url: '/products/monthly-volumes'
      }),
      transformResponse: ({ success, data }: NewResponse<GetMonthlyProductsVolumesResponse>) => {
        return success && data ? data.monthlyVolumes : []
      }
    })
  })
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  // Mutations
  useUpdateMonthlyProductsTargetsMutation,

  // Queries
  useGetMonthlyProductsTargetsQuery,
  useGetMonthlyProductsVolumesQuery
} = boltApi
